export const set = (
  key: string,
  value: any,
  expirationInSeconds = 60 * 60 * 24,
) => {
  const now = new Date();

  const expirationInMiliseconds = expirationInSeconds * 1000;

  localStorage.setItem(
    key,
    JSON.stringify({
      value,
      expiry: now.getTime() + expirationInMiliseconds,
    }),
  );

  window.dispatchEvent(
    new StorageEvent('storage', {
      key,
      newValue: value,
    }),
  );
};

export const get = <T = any>(key: string) => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  try {
    const item = JSON.parse(itemStr);

    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
    }

    return item.value as T;
  } catch (_) {
    return null;
  }
};

export const clearExpired = (): Promise<boolean> => {
  return new Promise((res) => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (!key) {
        continue;
      }

      const item = localStorage.getItem(key);

      if (!item) {
        continue;
      }

      if (item.includes('expiry')) {
        get(key);
      }
    }
    res(true);
  });
};
